import React from "react";
import InformTable from "../Components/InformTable";
import { InformFeatures } from "../Components/InformFeatures";

// Legacy Created: { "Name": "...", "Features": [{ "index": 0, "value": { "Name": "FeatureTest", "id": 0 } }] }
export const ProjectCreatedLegacy: React.FC<{ action: any }> = ({ action }) => {
    const general = [{ property: "Name", value: String(action.Name ?? "—") }];

    return (
        <div className="inform_panel">
            <InformTable data={general} label="General" />
            <InformFeatures features={action.Features} label="Features" />
        </div>
    );
};

// Legacy Updated: { "Name": { "old": "...", "new": "..." }, "Features": [{ "index": 0, "old": { ...deleted: true } }], "Id": "..." }
export const ProjectUpdatedLegacy: React.FC<{ action: any }> = ({ action }) => {
    const exclude = ["Id", "Features"];
    const entries = Object.entries(action).filter(([key]) => !exclude.includes(key));

    const dataOld = entries.map(([key, val]: [string, any]) => ({
        property: key,
        value: val?.old != null ? String(val.old) : "—",
    }));

    const dataNew = entries.map(([key, val]: [string, any]) => ({
        property: key,
        value: val?.new != null ? String(val.new) : "—",
    }));

    const deletedFeatures: any[] = (action.Features ?? [])
        .filter((f: any) => f.old?.deleted)
        .map((f: any) => ({ index: f.index, value: { Name: f.old?.Name, id: f.old?.Id } }));

    return (
        <div className="inform_panel">
            {dataOld.length > 0 && <InformTable data={dataOld} label="Old Version" />}
            {dataNew.length > 0 && <InformTable data={dataNew} label="New Version" />}
            {deletedFeatures.length > 0 && <InformFeatures features={deletedFeatures} label="Removed Features" />}
        </div>
    );
};
